export default __webpack_public_path__ + "static/media/upload-icon.027fc6b7.png";